var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 6,
    viewBox: "0 0 120 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28765 0C2.13157 0 2.69419 0.2 2.69419 0.5C2.69419 1.85 3.96008 2.8 6.49186 3.55C17.0409 6.6 48.6882 4.2 74.006 2.25C98.0579 0.4 112.967 -0.6 118.171 0.85C119.437 1.2 120 1.7 120 2.25C120 2.55 119.437 2.75 118.593 2.75C117.75 2.75 117.187 2.55 117.187 2.25C117.187 2 116.906 1.8 116.343 1.65C111.983 0.4 92.9943 1.85 74.5686 3.25C57.1275 4.55 38.2798 6 23.933 6C15.7751 6 9.02364 5.55 4.80401 4.3C1.56896 3.4 0.0217549 2.1 0.0217549 0.5C-0.1189 0.2 0.44372 0 1.28765 0Z",
    fill: "url(#paint0_linear_93_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_10",
    x1: 120,
    y1: 3,
    x2: 0.000205994,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F264DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#DA61FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#AA7CFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.04f23b8e0de20eff65e83fb244252986.svg";
export { ForwardRef as ReactComponent };